const Index = () =>
    import ( /* webpackChunkName: "menueditor" */ '@/components/menueditor/MyMenu')
export default {
    name: 'menueditor',
    path: 'menueditor/myMenu',
    redirect: '/menueditor/myMenu/index',
    meta: { label: 'menueditor' },
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
        path: 'index',
        meta: { label: 'Index', auth: [0, 1, 2, 3, 4, 5, 6, 7] },
        component: Index,
        props: true
    }]
}
